module.exports = __webpack_public_path__ + "static/media/tshirt.7b8ab0ad.png";